const debounce = () => {
  let id = 0
  const map = {}
  return (fn, wait, cancelPrevious = true) => {
    if (cancelPrevious) {
      for (const key in map) {
        delete map[key]
      }
    }

    const currentId = id

    map[currentId] = setTimeout(() => {
      if (map[currentId]) {
        fn()
      }
    }, wait)
    id++
  }
}

export {
  debounce
}



// WEBPACK FOOTER //
// ./client/utils/helpers.js